<template>  
  <div class="app-wrapper">

    <!-- Top Navigation -->
    <header class="top-nav indigo darken-3 z-depth-1">
      
      <div class="valign-wrapper" style="flex: 1;">
        <!-- NEW: Back Button instead of Hamburger Menu -->
        <a href="#!" @click.prevent="goBack" class="white-text hover-icon valign-wrapper" style="margin-right: 20px; padding: 5px 10px; border-radius: 20px; text-decoration: none;">
          <i class="material-icons" style="font-size: 1.5rem;">arrow_back</i>
          <span class="hide-on-small-only bold" style="margin-left: 5px;">Back</span>
        </a>
        
        <div class="logoimg center white circle z-depth-1" style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; overflow: hidden; margin-right: 12px;">
           <img src="@/assets/LTOlogo.png" style="width: 80%" />
        </div>
        <h5 class="white-text bold" style="margin: 0; font-size: 1.4rem; letter-spacing: 0.5px;">HR-DOS</h5>
      </div>             

      <div class="top-actions valign-wrapper">
        
        <!-- Notifications -->
        <div style="position: relative; margin-left: 20px; display: flex; align-items: center;">
          <a href="#!" @click.prevent="toggleNotifications" class="white-text hover-icon" style="position: relative; padding: 5px; border-radius: 50%; display: flex;">
            <i class="material-icons">notifications</i>
            <span v-if="unreadCount > 0" class="red accent-2 badge circle white-text" style="position: absolute; top: -2px; right: -2px; width: 18px; height: 18px; line-height: 18px; padding: 0; min-width: 0; border-radius: 50%; font-size: 0.7rem; text-align: center; font-weight: bold;">
              {{ unreadCount }}
            </span>
          </a>

          <div v-if="showNotifications" class="notification-dropdown z-depth-3">
            <div class="dropdown-header indigo darken-4 white-text">
              <span class="bold">Notifications</span>
              <a href="#!" @click.prevent="markAllAsRead" class="white-text right" style="font-size: 0.8rem; text-decoration: underline;">Mark all read</a>
            </div>
            
            <ul class="dropdown-content-list" style="max-height: 400px; overflow-y: auto; background-color: #f8f9fa;">
              <li v-if="notifications.length === 0" class="center-align grey-text" style="padding: 30px 20px; background-color: #fff;">
                <i class="material-icons" style="font-size: 2.5rem; color: #e0e0e0; margin-bottom: 10px;">notifications_none</i><br>
                No notifications found
              </li>

              <!-- ================= UNREAD SECTION ================= -->
              <template v-if="unreadNotifications.length > 0">
                <div class="notif-section-title">New</div>
                <li v-for="notif in unreadNotifications" :key="'unread-'+notif.id" 
                  class="notification-item unread-notif"
                  @click="handleNotificationClick(notif)">
                  
                  <div class="unread-dot indigo darken-1"></div>

                  <div style="flex: 1;">
                    <div class="notif-title bold indigo-text text-darken-4">
                      {{ notif.data.title || 'System Alert' }}
                    </div>
                    <div class="notif-text grey-text text-darken-3">
                      {{ notif.data.message }}
                    </div>
                    <div class="notif-time indigo-text text-lighten-1" style="font-size: 0.7rem; margin-top: 4px; font-weight: 600;">
                      {{ formatDate(notif.created_at) }}
                    </div>
                  </div>
                </li>
              </template>

              <!-- ================= READ SECTION ================= -->
              <template v-if="readNotifications.length > 0">
                <div class="notif-section-title" v-if="unreadNotifications.length > 0">Earlier</div>
                <li v-for="notif in readNotifications" :key="'read-'+notif.id" 
                  class="notification-item read-notif"
                  @click="handleNotificationClick(notif)">
                  
                  <div style="width: 8px; margin-right: 12px; flex-shrink: 0;"></div> <!-- Spacer -->

                  <div style="flex: 1;">
                    <div class="notif-title grey-text text-darken-1">
                      {{ notif.data.title || 'System Alert' }}
                    </div>
                    <div class="notif-text grey-text text-darken-1">
                      {{ notif.data.message }}
                    </div>
                    <div class="notif-time grey-text text-lighten-2" style="font-size: 0.7rem; margin-top: 4px;">
                      {{ formatDate(notif.created_at) }}
                    </div>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </div>

        <!-- Profile Dropdown -->
        <div style="position: relative; display: flex; align-items: center;">
          <div @click="toggleProfileMenu" class="hide-on-small-only valign-wrapper hover-icon" style="margin-left: 15px; padding: 4px 10px; border-radius: 20px; cursor: pointer;">
            <img :src="getProfilePhoto()" alt="Avatar" class="circle" style="width: 32px; height: 32px; margin-right: 10px; object-fit: cover;" />
            <div class="white-text" style="display: flex; flex-direction: column; line-height: 1.1;">
              <span class="bold" style="font-size: 0.85rem; text-transform: uppercase;">{{ getDisplayName() }}</span>
              <span style="font-size: 0.7rem; color: #c5cae9;">{{ extractTitleInParentheses(currentUser?.employee?.position_title) || currentUser?.role || 'System User' }}</span>
            </div>
            <i class="material-icons white-text" style="margin-left: 5px; font-size: 1.2rem;">keyboard_arrow_down</i>
          </div>

          <div v-if="showProfileMenu" class="profile-dropdown z-depth-3">
            <ul class="dropdown-content-list" style="max-height: none;">
              <li class="profile-dropdown-item" @click="logout">
                <i class="material-icons" style="color: #ff5252; margin-right: 10px; vertical-align: middle;">power_settings_new</i>
                <span class="bold" style="color: #ff5252; font-size: 0.95rem;">Logout</span>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </header>

    <!-- Main Content Area (No Sidebar offset!) -->
    <main class="main-content grey lighten-5">
      <!-- Added a container to keep forms nicely centered and readable -->
      <div class="form-container">
        <slot />
      </div>
    </main>

  </div>
</template>

<script>
import { api, apiURL } from "@/axios";
import defaultPic from '@/assets/picDefault.png';

export default {
  name: "FormLayout",
  props: {
    title: String,
    // Optional prop to define where the back button goes (defaults to going back 1 step in history)
    backRoute: {
      type: String,
      default: null
    }
  },
  data() {
    let cachedUser = null;
    try {
      cachedUser = JSON.parse(localStorage.getItem('hrdos_user'));
    } catch (e) {
      cachedUser = null;
    }

    return { 
      notifications: [], 
      showNotifications: false, 
      showProfileMenu: false, 
      currentUser: cachedUser,
    };
  },
  computed: {
    unreadNotifications() {
      return this.notifications.filter(n => n.read_at === null);
    },
    readNotifications() {
      return this.notifications.filter(n => n.read_at !== null);
    },
    unreadCount() {
      return this.unreadNotifications.length;
    }
  },
  watch: {
    $route() {
      this.showProfileMenu = false; 
      this.showNotifications = false;
    }
  },
  mounted() {
    if (this.title) {
      document.title = this.title;
    }
    
    this.fetchNotifications();
    this.fetchCurrentUser(); 
  },
  beforeUnmount() {
    if (window.Echo && this.currentUser) {
      window.Echo.leave(`App.Models.User.${this.currentUser.id}`);
    }
  },
  methods: {
    goBack() {
      if (this.backRoute) {
        this.$router.push(this.backRoute);
      } else {
        this.$router.go(-1); // Automatically goes back to the previous page
      }
    },

    async fetchCurrentUser() {
      try {
        const response = await api.get('/user'); 
        this.currentUser = response.data;
        localStorage.setItem('hrdos_user', JSON.stringify(response.data));
        this.initializeEcho();
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },

    getDisplayName() {
      if (!this.currentUser) return 'Loading...';
      if (this.currentUser.employee && this.currentUser.employee.first_name) {
        const first = this.currentUser.employee.first_name;
        const last = this.currentUser.employee.last_name || '';
        return `${first} ${last}`.trim();
      }
      return this.currentUser.username || 'System Admin';
    },

    getProfilePhoto() {
      if (this.currentUser?.employee?.profile_photo) {
        const baseUrl = apiURL.replace(/\/api\/?$/, '');
        return `${baseUrl}/storage/${this.currentUser.employee.profile_photo}`;
      }
      
      return defaultPic;
    },

    initializeEcho() {
      if (window.Echo && this.currentUser) {
        window.Echo.private(`App.Models.User.${this.currentUser.id}`)
          .notification((notification) => {
            this.notifications.unshift({
              id: notification.id,
              data: notification,
              read_at: null, // Set read_at to null for computed properties
              created_at: new Date().toISOString()
            });

            if (window.M && window.M.toast) {
              let toastHtml = `<span style="font-weight: 500;">${notification.message}</span>`;
              if (notification.url) {
                toastHtml += `<button class="btn-flat toast-action" onclick="window.location.href='${notification.url}'" style="color: #fff; font-weight: bold; margin-left: 15px;">VIEW</button>`;
              }
              window.M.toast({
                html: toastHtml,
                classes: 'rounded pink accent-3 white-text',
                displayLength: 5000 
              });
            }
          });
      }
    },

    toggleNotifications() {
      this.showNotifications = !this.showNotifications;
      if (this.showNotifications) {
        this.showProfileMenu = false; 
        this.fetchNotifications();
      }
    },

    toggleProfileMenu() {
      this.showProfileMenu = !this.showProfileMenu;
      if (this.showProfileMenu) this.showNotifications = false; 
    },

    async fetchNotifications() {
      try {
        const response = await api.get('/notifications/all');
        this.notifications = response.data.notifications?.data || response.data.notifications || response.data.data || [];
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    },

    async handleNotificationClick(notification) {
      // Mark as read locally first for instant UI response
      notification.read_at = new Date().toISOString();

      if (notification.data.url) {
        this.showNotifications = false; 
        this.$router.push(notification.data.url);
      }

      try {
        await api.post(`/notifications/${notification.id}/read`);
      } catch (error) {
        console.error("Error marking notification read:", error);
      }
    },

    async markAllAsRead() {
      try {
        await api.post('/notifications/read-all');
        // Update read_at locally for all instead of emptying the array
        this.notifications.forEach(n => n.read_at = new Date().toISOString());
      } catch (error) {
        console.error("Error marking all read:", error);
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    },

    extractTitleInParentheses(title) {
      if (!title) return '';
      const match = title.match(/\(([^)]+)\)/);
      
      return match ? match[1] : title;
    },

    logout() {
        localStorage.removeItem("token");
        sessionStorage.removeItem("token");
        localStorage.removeItem("hrdos_user"); 
        this.$router.push("/");
    },
  }
};
</script>

<style scoped>
/* ========================================================= */
/* FORM LAYOUT POSITIONING                                   */
/* ========================================================= */
.app-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 72px;
  z-index: 1200; 
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.main-content {
  flex: 1;
  margin-top: 72px; 
  margin-left: 0; /* NO SIDEBAR OFFSET */
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 72px);
  width: 100%;
}

/* Centers the form content nicely on large screens */
.form-container {
  width: 100%;
  max-width: 1200px; /* Limits how wide the form stretches */
  margin: 0 auto;
  padding: 40px 20px;
}

/* ========================================================= */
/* DROPDOWNS & UTILITIES                                     */
/* ========================================================= */
.notification-dropdown,
.profile-dropdown {
  position: absolute;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  z-index: 2000;
  transform-origin: top right;
  animation: slideDown 0.2s ease-out;
}

.notification-dropdown {
  top: 45px; 
  right: -10px;
  width: 320px;
}

.profile-dropdown {
  top: 55px; 
  right: 0;
  width: 180px;
}

.profile-dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
}

.profile-dropdown-item:hover {
  background-color: #ffebee; 
}

.dropdown-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
}

.dropdown-content-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

/* NOTIFICATION ITEM STYLES */
.notif-section-title {
  padding: 8px 16px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #757575;
  text-transform: uppercase;
  background-color: #f4f6f9;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #e0e0e0;
}

.notification-item {
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
  display: flex;
  align-items: flex-start;
  position: relative;
}

.read-notif {
  background-color: #ffffff;
  border-bottom: 1px solid #eeeeee;
  border-left: 4px solid transparent;
}

.read-notif:hover {
  background-color: #f5f5f5;
}

.unread-notif {
  background-color: #e8eaf6; 
  border-left: 4px solid #3f51b5; 
  border-bottom: 1px solid #c5cae9;
  margin-bottom: 2px;
}

.unread-notif:hover {
  background-color: #c5cae9;
}

.unread-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 6px;
  margin-right: 12px;
  flex-shrink: 0;
}

.notif-title {
  font-size: 0.9rem;
  margin-bottom: 2px;
  line-height: 1.2;
}

.notif-text {
  font-size: 0.85rem;
  line-height: 1.3;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-10px) scale(0.95); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

body {
  margin: 0;
  overflow-x: hidden;
  background-color: #f4f6f9; 
}

.bold {
  font-weight: 600 !important;
}

.hover-icon {
  transition: background-color 0.2s;
}
.hover-icon:hover {
  background-color: rgba(255, 255, 255, 0.2); 
}

@media only screen and (max-width: 600px) {
  .form-container {
    padding: 20px 10px; 
  }
}
</style>